import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.climbStepTwoCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.climbStepTwoCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.climbStepTwoCollections.data.climbStepTwoCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.climbStepTwoCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
